import * as Sentry from "@sentry/react";

export function connectSentry() {
  if (process.env.USE_SENTRY === "true") {
    Sentry.init({
      dsn: "https://8d74a95317c53c63b9a85d56112d152b@o4511665252007936.ingest.de.sentry.io/4511669947859024",
      dataCollection: {
        // To disable sending user data and HTTP bodies, uncomment the lines below. For more info visit:
        // https://docs.sentry.io/platforms/javascript/guides/react/configuration/options/#dataCollection
        userInfo: false,
        httpBodies: [],
        queryParams: false,
        httpHeaders: {
          request: false,
          response: false,
        },
        cookies: false,
        stackFrameVariables: false,
      },
      integrations: [
        Sentry.feedbackIntegration({
          colorScheme: "system",
          autoInject: false,
        }),
        Sentry.replayIntegration(),
        Sentry.browserTracingIntegration(),
      ],
      replaysSessionSampleRate: 0.1,
      replaysOnErrorSampleRate: 1.0,
      tracesSampleRate: 1.0,
    });
  }
}
